/**
 * 懒创建, 常用语 class 类中确保单例且延迟创建
 * 如原写法
 * get Component() {
 *   if (!this.clazzHolder) {
 *     this.clazzHolder = observer(() => this.getComponent());
 *   }
 *   return this.clazzHolder;
 * }
 *
 * 改造后:
 * get Component() {
 *   return lazyInit(this, 'clazzHolder', observer(::this.getComponent));
 * }
 */
export default function lazyInit(container, holderName, value) {
  if (!container[holderName]) {
    container[holderName] = value;
  }
  return container[holderName];
}
